export default __webpack_public_path__ + "static/media/shop.3e45aa03.svg";